module.exports = __webpack_public_path__ + "img/hk_feature3.77dbd728.jpg";